declare const L;
declare const jQuery;
const $ = jQuery;

export default function map(houzez_single_property_map) {

  const mapData = houzez_single_property_map;

  if (!mapData) {return;}
  if (mapData.lat && mapData.lng) {

    const tileLayer = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
    });

    const mapCenter = L.latLng(mapData.lat, mapData.lng);

    const mapOptions = {
      dragging: !L.Browser.mobile,
      center: mapCenter,
      zoom: 14,
      zoomControl: true,
      tap: false,
      title: mapData.title
    };

    const houzezMap = L.map('houzez-single-listing-map', mapOptions);
    houzezMap.scrollWheelZoom.disable();
    houzezMap.addLayer(tileLayer);

    const iconOptions = {
      iconUrl: mapData.marker,
      iconSize: [44, 56],
      iconAnchor: [20, 57],
      popupAnchor: [1, -57],
      iconRetinaUrl: mapData.retinaMarker
    };

    const markerOptions = {
      riseOnHover: true,
      icon: L.icon(iconOptions)
    };

    L.marker(mapCenter, markerOptions).addTo(houzezMap);

    $('a[href="#pills-map"], a[href="#property-address"]').on('shown.bs.tab', function () {
      houzezMap.invalidateSize();
      houzezMap.panTo(houzezMap.getCenter());
    });

  } // End lat and lng if

}
